/*
 * File for registration of sliders
 *
 */

const image_swiper = new Swiper(".image-slider__swiper", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

const swiper = new Swiper(".three-slides-slider", {
  loop: false,
  slidesPerView: 1,
  spaceBetween: 30,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 3,
    },
  },
});

const logos_swiper = new Swiper(".logos-slider__wrapper", {
  loop: false,
  slidesPerView: 2,
  spaceBetween: 30,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    991: {
      slidesPerView: 5,
    },
  },
});

const customer_swiper = new Swiper(".customer-reviews-text-slider", {
  direction: "vertical",
  slidesPerView: 2,
  mousewheel: true,
  spaceBetween: 40,
  // autoHeight: true,
  cssMode: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    // hide: true,
  },
});

const four_swiper = new Swiper(".four-slides-slider", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 30,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 4, // Display 4 slides on desktop (adjust the breakpoint as needed)
    },
  },
});

const video_swiper = new Swiper(".customer-reviews-video-slider", {
  slidesPerView: 1,
  cssMode: true,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

var swiper_vertical = new Swiper(".mySwiper", {
  direction: "vertical",
  effect: "slide",
  slidesPerView: "auto",
  mousewheel: true,
  spaceBetween: 20,
  autoHeight: true,
  cssMode: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    // hide: true,
  },
});

const banner_slider = new Swiper(".banner-slider", {
  crossFade: true,
  effect: "fade",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  pagination: {
    
    el: ".swiper-pagination",
    clickable: true,
  },
});
